import { render, staticRenderFns } from "./registro_edicion_departamentos_prolipa.vue?vue&type=template&id=352cf412&scoped=true"
import script from "./registro_edicion_departamentos_prolipa.vue?vue&type=script&lang=js"
export * from "./registro_edicion_departamentos_prolipa.vue?vue&type=script&lang=js"
import style0 from "./registro_edicion_departamentos_prolipa.vue?vue&type=style&index=0&id=352cf412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352cf412",
  null
  
)

export default component.exports